import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { UserService } from 'src/app/services/Modules/user.service';
import { USER_TYPE } from 'src/app/includes/global';
import { IcdCodesService } from 'src/app/services/Modules/icd-codes.service';
import { lastValueFrom } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { ElasticSeachService } from 'src/app/services/elasticSearch.service';


@Component({
  selector: 'app-add-icd-to-provider',
  templateUrl: './add-icd-to-provider.component.html',
  styleUrls: ['./add-icd-to-provider.component.css']
})

export class AddIcdToProviderComponent implements OnInit {
  providers: any = [];
  selectedProvider;
  providertoShare: any;
  currentUser: any;
  providerDropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'full_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 10,
    allowSearchFilter: true,
    enableCheckAll: true,
  };
  sharedProviders: any = [];
  companies: any;
  company_id: any;
  selectedCompany: any;
  selectedFilter = 'All';
  dataSource: any = new MatTableDataSource([]);
  icds = [];
  valueToBeSearched: string = "";
  displayedColumns: string[] = ['Code', 'Description', 'Provider'];
  timeoutId: any;
  isIcdLoaded = false;
  searchCompanyText: any;

  constructor(
    private elasticSearchService: ElasticSeachService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastr: ToastrService,
    private companyService : CompanyService,
    private userService: UserService,
    private _ICDcodesService: IcdCodesService,
    ) {
    this.currentUser = this.authService.currentUser;
  }

  async ngOnInit() {
    this.company_id = this.currentUser.company_id;
    await this.initAssociatedCompanies();
    this.displayAllCodes();
  }
  
  onCompanyChange($event) {
    this.selectedCompany = $event.value;
    this.getProviders();
  }

  async initAssociatedCompanies() {
    let query = {
      adminId: this.currentUser._id,
      parentCompanyId: this.currentUser.company_id
    }
    this.companyService.getAllAssosiatedCompaniesWithCount(query).subscribe(async (response: any) => {
      if (response.status == 200) {
        this.companies = response.data;
        this.selectedCompany = this.companies[0]._id
        await this.getProviders();
      }
      else {
        this.toastr.error(response.message, "ERROR");
      }

    })
  }

  async displayAllCodes(page = 1, search = "") {
    let res: any = await lastValueFrom(this.elasticSearchService.searchICDCodewithPagination(search, (page + 1) * 10, 0, false, this.currentUser.company_id));
    if (res.status === 200) {
      this.icds = res.data;
      this.dataSource.data = this.icds;
    }
    else
      this.toastr.warning(res.message)

  }

  setValueToBeSearched(filterValue: any) {
    this.valueToBeSearched = filterValue.trim();
  }

  async searchValue(page = 1) {
    clearTimeout(this.timeoutId);
    this.isIcdLoaded = true;
    this.timeoutId = setTimeout(() => {
      this.displayAllCodes(page, this.valueToBeSearched);
    }, 2000);
    this.isIcdLoaded = false;
  }

  displayProviderAssociatedIcds() {
    let filter = { provider_ids_ref: this.selectedProvider };
    if (window.location.pathname.includes('company')) {           // for admin side
      filter['company_id'] = this.selectedCompany;
    }
    else
      filter['company_id'] = this.currentUser.company_id;       // for user side
    this._ICDcodesService.fetchProviderAssociatedIcds(filter, {}, false)
      .subscribe((res: any) => {
        if (res.status === 200) {
          if (res.data) {
            this.icds = res.data;
            this.dataSource.data = this.icds;
          }
          else
            this.icds = [];
        }
        else if (res.status === 500)
          this.toastr.warning(res.message)

      })

  }


  async getProviders() {
    const filter = {
      is_activated: 'true',
      user_type: USER_TYPE.DOCTOR,
      company_id: this.selectedCompany
    }

    const projection = {
      'account_type': 1,
      'first_name': 1,
      'last_name': 1,
      'title': 1,
      'product_owner': 1,
      'full_name': 1
    }

    const companyUsers: any = await lastValueFrom(this.userService.getUsers(filter, projection));
    if (companyUsers.status === 200) {
      this.providers = companyUsers.data;
      if (Array.isArray(this.providers) && this.providers.length > 0)
        this.providers.sort((a, b) => a.full_name.localeCompare(b.full_name));
    }

  }

  onProviderSelect($event, icd) {
    if (this.sharedProviders.indexOf($event._id) === -1) {
      this.sharedProviders.push($event._id);
      this.shareIcds(icd);
    }
  }
  onProviderDeselect($event, icd) {
    let filter = { provider_ids_ref: $event._id, icd_code_id: icd._id, company_id: this.selectedCompany, isDeleteAll: false }
    this.deleteIcdAssociation(filter);

  }

  async shareIcds(icd: any) {
    let query = { provider_ids_ref: this.sharedProviders, company_id: this.selectedCompany, icd_code: icd };

    let response: any = await lastValueFrom(this._ICDcodesService.createIcdProviderAssociation(query))
    if (response.status == 200)
      this.toastr.success(response.message, "Success");
    else
      this.toastr.error(response.message, "ERROR");
  }
  
  async deleteIcdAssociation(filter) {

    console.log("icdddddddDD: ", filter)

    let res: any = await lastValueFrom(this._ICDcodesService.removeIcdProviderAssociation(filter))
    if (res.status === 200) {
      this.toastr.success(res.message, "Success");
    }
    else
      this.toastr.warning(res.message)
  }


  onAllProviderSelect(providers, icd) {
    const allProviders = providers.map(provider => provider._id);
    for (const id of allProviders) {
      if (!this.sharedProviders.includes(id)) {
        this.sharedProviders.push(id);
      }
    }
    this.shareIcds(icd);
  }
  onAllProviderDeSelect($event, icd) {
    this.sharedProviders = $event;
    let filter = {icd_code_id: icd._id, company_id: this.selectedCompany, isDeleteAll: true }

    this.deleteIcdAssociation(filter);
  }

  onChangeFilter($event) {
    this.selectedFilter = $event.value.trim();
    if (this.selectedFilter === 'All') {
      this.dataSource.filter = '';
    } else {
      this.dataSource.filter = this.selectedFilter;
    }
  }
}


